<template>
  <div>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      :width=width
      :height=height
      :viewBox=viewBox
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
        :fill=colorArrows
        stroke="none"
      >
        <path
          d="M5795 7499 c-187 -32 -504 -85 -705 -118 -509 -83 -2443 -410 -2455
-415 -5 -3 7 -5 28 -5 38 -1 2189 87 2816 114 189 9 345 14 346 13 1 -2 -38
-144 -87 -316 -49 -173 -87 -316 -85 -319 3 -2 360 85 795 195 l790 199 -19
-66 c-10 -36 -48 -166 -83 -289 -41 -145 -59 -221 -51 -218 13 5 1629 407
1708 425 l37 9 0 -107 c0 -114 11 -404 15 -409 4 -5 1145 669 1145 677 0 5
-1134 650 -1158 659 -4 1 -6 -133 -4 -298 l3 -300 -606 0 -605 0 6 24 c3 12
34 115 68 227 40 130 59 205 52 207 -10 2 -1618 -271 -1673 -285 -15 -3 -23
-1 -23 7 0 7 25 108 55 225 30 116 55 215 55 218 0 10 11 11 -365 -54z"
        />
        <path
          d="M8828 5420 l3 -320 -606 0 c-333 0 -605 1 -605 3 0 1 31 103 69 227
38 124 69 226 67 227 -1 1 -384 -63 -850 -143 -467 -79 -851 -142 -854 -140
-2 3 20 106 51 228 31 122 55 223 54 224 -1 1 -132 -20 -292 -48 -159 -27
-501 -84 -760 -127 -1471 -243 -2475 -416 -2424 -419 52 -3 2365 89 2959 117
96 5 177 7 179 5 3 -3 -74 -283 -158 -575 l-19 -67 790 200 c435 109 793 197
796 194 3 -3 -31 -131 -75 -283 -45 -153 -80 -279 -79 -280 1 -1 379 92 841
207 461 115 856 212 877 215 l38 7 1 -119 c1 -65 4 -170 8 -234 l6 -116 565
334 c311 183 570 337 577 341 10 6 -1132 662 -1154 662 -4 0 -7 -144 -5 -320z"
        />
        <path
          d="M8828 3730 l3 -320 -606 0 c-333 0 -605 3 -605 6 0 6 128 426 137
450 4 11 -109 -8 -1288 -209 l-425 -72 57 227 c42 169 53 228 43 228 -7 0
-606 -99 -1331 -221 -725 -121 -1509 -252 -1743 -291 -234 -39 -429 -75 -435
-80 -5 -5 27 -6 75 -3 47 3 533 24 1080 45 1005 41 1624 66 1890 78 l145 7
-91 -320 c-50 -176 -90 -321 -89 -322 0 -1 356 88 790 197 435 110 792 199
796 197 3 -1 -32 -128 -77 -282 -45 -154 -78 -281 -73 -283 4 -2 95 19 201 47
404 105 1521 381 1541 381 4 0 8 -55 8 -122 1 -68 4 -176 8 -240 l6 -118 572
338 c315 185 573 340 573 344 0 6 -1133 650 -1155 656 -7 2 -9 -99 -7 -318z"
        />
      </g>
      <g
        transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
        :fill=colorText
        stroke="none"
      >
        <path
          d="M28787 6003 c-4 -3 -7 -151 -7 -327 l0 -321 -79 3 c-123 5 -121 7
-121 -153 0 -160 -1 -158 121 -153 l79 3 2 -760 3 -760 163 -3 162 -2 0 762 0
763 152 0 153 0 0 150 0 150 -153 0 -152 0 0 328 0 327 -158 0 c-87 0 -162 -3
-165 -7z"
        />
        <path
          d="M17435 5389 c-488 -66 -797 -526 -736 -1094 14 -129 30 -196 65 -284
43 -108 106 -202 191 -286 186 -185 424 -265 732 -244 281 19 534 179 701 445
18 28 32 57 32 65 0 12 -96 79 -114 79 -3 0 -31 16 -63 35 -32 19 -65 35 -74
35 -8 0 -37 -33 -63 -75 -109 -173 -246 -262 -434 -285 -191 -24 -367 38 -485
170 -91 101 -137 208 -152 353 l-7 67 707 0 708 0 -6 128 c-16 346 -123 574
-350 745 -80 60 -182 109 -278 132 -80 19 -281 27 -374 14z m270 -301 c104
-22 240 -117 304 -212 33 -49 76 -149 85 -193 l6 -33 -522 0 -521 0 7 38 c16
101 103 237 198 309 130 98 273 127 443 91z"
        />

        <path
          d="M19510 5384 c-214 -40 -421 -168 -535 -331 -140 -200 -195 -424 -174
-718 36 -536 451 -900 972 -854 170 15 344 97 463 218 l64 65 0 -117 0 -117
165 0 165 0 -2 913 -3 912 -160 0 -160 0 -5 -118 -5 -118 -45 47 c-94 97 -234
179 -360 211 -87 22 -281 25 -380 7z m345 -296 c71 -15 165 -60 224 -105 98
-75 190 -222 216 -348 19 -92 19 -285 -1 -383 -40 -197 -183 -378 -351 -442
-111 -42 -267 -48 -391 -16 -279 74 -450 380 -413 738 42 402 345 638 716 556z"
        />
        <path
          d="M21910 5386 c-113 -21 -258 -103 -340 -191 l-25 -27 -5 94 -5 93
-160 0 -160 0 -3 -912 -2 -913 164 0 164 0 5 563 c4 456 7 577 20 641 37 188
154 324 305 355 75 16 190 14 248 -4 103 -32 196 -131 224 -240 10 -37 14
-213 17 -683 l4 -632 162 2 162 3 0 640 c0 737 -3 773 -66 903 -76 156 -203
253 -394 302 -89 23 -213 25 -315 6z"
        />
        <path
          d="M26310 5394 c-423 -52 -726 -315 -826 -716 -22 -87 -26 -126 -26
-248 1 -130 4 -157 31 -255 48 -179 106 -280 230 -408 165 -170 372 -268 604
-286 328 -26 600 70 808 285 120 125 189 252 234 429 36 140 36 336 0 483 -86
357 -359 624 -710 697 -79 16 -278 27 -345 19z m216 -295 c182 -32 342 -136
428 -278 52 -85 74 -149 89 -263 34 -249 -29 -463 -181 -613 -116 -117 -251
-169 -432 -169 -199 1 -328 50 -446 170 -83 84 -146 200 -169 309 -19 91 -19
262 0 362 61 321 384 540 711 482z"
        />

        <path
          d="M23270 5130 l0 -1600 160 0 160 0 0 123 0 122 78 -75 c93 -90 194
-153 299 -187 107 -34 310 -43 430 -19 388 80 647 388 694 826 27 244 -37 506
-170 706 -53 79 -191 212 -267 255 -146 86 -306 124 -474 115 -135 -7 -212
-27 -330 -84 -75 -37 -113 -63 -177 -126 l-83 -79 0 812 0 811 -160 0 -160 0
0 -1600z m1040 -41 c186 -51 313 -163 393 -344 41 -94 57 -178 57 -303 0 -141
-20 -240 -70 -346 -77 -164 -198 -266 -367 -310 -71 -19 -199 -21 -275 -5
-207 44 -380 218 -444 449 -26 93 -26 331 -1 414 57 184 165 323 312 399 67
35 186 66 255 66 37 1 98 -8 140 -20z"
        />
        <path
          d="M27860 5130 l0 -1600 165 0 165 0 0 1600 0 1600 -165 0 -165 0 0
-1600z"
        />
        <path
          d="M12740 6499 c-171 -11 -311 -43 -480 -110 -291 -116 -562 -349 -719
-617 -74 -128 -144 -306 -169 -432 -31 -157 -33 -183 -29 -375 5 -216 11 -261
55 -425 13 -50 67 -180 103 -252 128 -254 351 -484 599 -621 155 -85 379 -156
588 -186 262 -39 597 23 876 160 296 147 519 372 664 673 125 259 180 547 153
803 -19 178 -42 283 -88 408 -85 226 -208 414 -366 561 -331 306 -720 442
-1187 413z m264 -320 c179 -31 255 -55 386 -120 302 -149 542 -460 613 -794
47 -218 48 -315 5 -535 -26 -135 -91 -286 -180 -420 -151 -226 -439 -427 -688
-480 -30 -6 -71 -16 -91 -21 -47 -12 -331 -12 -378 0 -20 5 -61 15 -91 21
-315 67 -638 330 -779 632 -83 179 -113 316 -113 530 0 161 5 196 48 351 137
492 594 837 1118 846 50 0 117 -4 150 -10z"
        />
        <path
          d="M15613 5389 c-190 -22 -346 -86 -488 -199 -153 -123 -245 -260 -311
-465 -28 -87 -29 -96 -29 -295 0 -200 1 -207 29 -290 121 -357 383 -582 755
-650 74 -13 275 -14 346 -1 151 27 288 81 383 150 l42 31 0 183 c0 101 -3 187
-7 190 -3 4 -34 -21 -68 -55 -79 -80 -196 -150 -310 -184 -167 -50 -373 -34
-505 38 -130 71 -217 164 -276 293 -100 217 -77 517 53 707 63 91 159 173 239
202 27 11 54 23 60 27 6 5 57 16 113 24 83 13 118 14 184 5 183 -25 347 -104
441 -213 25 -28 49 -46 55 -43 7 5 11 67 11 187 0 211 7 198 -132 266 -189 94
-351 119 -585 92z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "TheLogo",
  props: {
    // width: {
    //   type: Number,
    //   default: 320
    // },
    height: {
      type: Number,
      default: 100
    },
    viewBox: {
      type: String,
      default: "0 0 3200 1000"
    },
    square: {
      type: Boolean,
      default: false
    },
    colorText: {
      type: String,
      default: "#000000"
    },
    colorArrows: {
      type: String,
      default: "#0079c6"
    }
  },
  computed: {
    width: function() {
      return this.height * (this.square ? 1 : 3.2)
    }
  }
};
</script>
